import SearchableDropdown from '../../../../../components/SearchableDropdown';
import { FINANCIAL_YEARS } from '../utils/helpers';

const FilterBar = ({
    filters, setFilters,
    accounts, accountsLoading,
    onApply, onReset,
}) => {
    const handleFYChange = (val) => {
        const fy = FINANCIAL_YEARS.find(f => f.value === val);
        setFilters(prev => ({
            ...prev,
            financialYear: val,
            fromDate: fy ? fy.fromDate : prev.fromDate,
            toDate: fy ? fy.toDate : prev.toDate,
        }));
    };

    return (
        <div className="tw-bg-white tw-rounded-xl tw-border tw-border-gray-100 tw-shadow-sm tw-p-4 tw-mb-4">
            <div className="tw-flex tw-flex-wrap tw-items-end tw-gap-3">
                {/* Financial Year */}
                <div className="tw-w-44">
                    <label className="tw-text-xs tw-font-medium tw-text-gray-500 tw-mb-1 tw-block">
                        Financial Year
                    </label>
                    <select
                        value={filters.financialYear}
                        onChange={e => handleFYChange(e.target.value)}
                        className="tw-w-full tw-px-2.5 tw-py-1.5 tw-border tw-border-gray-200 tw-rounded tw-text-xs tw-text-gray-700 focus:tw-outline-none focus:tw-border-blue-500 focus:tw-ring-1 focus:tw-ring-blue-500 tw-bg-white"
                    >
                        {FINANCIAL_YEARS.map(fy => (
                            <option key={fy.value} value={fy.value}>{fy.label}</option>
                        ))}
                    </select>
                </div>

                {/* Account */}
                <div className="tw-w-64">
                    <label className="tw-text-xs tw-font-medium tw-text-gray-500 tw-mb-1 tw-block">
                        Account
                    </label>
                    <SearchableDropdown
                        value={filters.accountCode || ''}
                        onChange={(v) => setFilters(prev => ({ ...prev, accountCode: v || '' }))}
                        options={accounts.map(a => ({
                            value: a.ac_code,
                            label: a.ac_code ? `${a.ac_code} - ${a.name}` : a.name,
                        }))}
                        placeholder={accountsLoading ? 'Loading accounts…' : 'Select Account'}
                        disabled={accountsLoading}
                        loading={accountsLoading}
                        small
                    />
                </div>

                <div className="tw-w-px tw-h-7 tw-bg-gray-200 tw-mx-1" />

                {/* From Date */}
                <div className="tw-w-36">
                    <label className="tw-text-xs tw-font-medium tw-text-gray-500 tw-mb-1 tw-block">
                        From Date
                    </label>
                    <input
                        type="date"
                        value={filters.fromDate}
                        onChange={e => setFilters(prev => ({ ...prev, fromDate: e.target.value }))}
                        className="tw-w-full tw-px-2.5 tw-py-1.5 tw-border tw-border-gray-200 tw-rounded tw-text-xs tw-text-gray-700 focus:tw-outline-none focus:tw-border-blue-500 focus:tw-ring-1 focus:tw-ring-blue-500"
                    />
                </div>

                {/* To Date */}
                <div className="tw-w-36">
                    <label className="tw-text-xs tw-font-medium tw-text-gray-500 tw-mb-1 tw-block">
                        To Date
                    </label>
                    <input
                        type="date"
                        value={filters.toDate}
                        onChange={e => setFilters(prev => ({ ...prev, toDate: e.target.value }))}
                        className="tw-w-full tw-px-2.5 tw-py-1.5 tw-border tw-border-gray-200 tw-rounded tw-text-xs tw-text-gray-700 focus:tw-outline-none focus:tw-border-blue-500 focus:tw-ring-1 focus:tw-ring-blue-500"
                    />
                </div>

                <button
                    onClick={onApply}
                    className="tw-px-3.5 tw-py-1.5 tw-bg-blue-600 tw-text-white tw-rounded tw-text-xs tw-font-medium hover:tw-bg-blue-700 tw-transition-colors"
                >
                    Apply
                </button>
                <button
                    onClick={onReset}
                    className="tw-px-3.5 tw-py-1.5 tw-text-gray-500 tw-rounded tw-text-xs tw-font-medium tw-border tw-border-gray-200 hover:tw-bg-gray-50 tw-transition-colors"
                >
                    Reset
                </button>
            </div>
        </div>
    );
};

export default FilterBar;
